import { useMobileConfigUpdateChecker } from 'hooks/useMobileConfigUpdateChecker'
import { useUpdateChecker } from 'hooks/useUpdateChecker'

const UpdateChecker = () => {
  useUpdateChecker()
  // 暫時不檢查更新
  useMobileConfigUpdateChecker()
  return <></>
}

export default UpdateChecker
